module.exports = __webpack_public_path__ + "img/ereszkalkulator_haz_l_nyeregteto_szines.282fc17e.png";